import useMmaLogged from './urql/useMmaLogged';

import type {
  MmaSessionFragmentFragment,
  UserFragmentFragment,
} from '~/graphql/mma/generated/graphql';

const isUserFragment = (
  value: MmaSessionFragmentFragment,
): value is UserFragmentFragment => (

  value.__typename === 'User'
);

/**
 * It should be call only in PRIVATE pages. Other way it will and should fail.
 * It can be a user or entity session
 * */
export const useSession = () => {
  const { data } = useMmaLogged();
  const session = computed<MmaSessionFragmentFragment>(() => {
    const value = data.value?.mmaLogged;
    if (!value) {
      throw new Error('User not logged in. Please reveiw your code');
    }
    return value;
  });

  const isUser = computed(() => isUserFragment(session.value));
  const user = computed(() => (isUserFragment(session.value) ? session.value : undefined));
  const entity = computed(() => (isUserFragment(session.value) ? undefined : session.value));
  const entities = computed(() => {
    if (entity.value) {
      return [entity.value];
    }
    return user.value?.entities ?? [];
  });

  return {
    session,
    isUserFragment,
    isUser,
    user,
    entity,
    entities,
  };
};
